// Adresse Sirene FR renvoyée en une seule chaîne (« <voie> <CP 5 chiffres> <commune> »). On en dérive
// au mieux voie / code postal / ville pour pré-remplir le formulaire de facturation ; à défaut (format
// inattendu, adresse étrangère), tout part dans « adresse » et l'utilisateur complète à la main.
export function splitCompanyAddress(raw: string | null | undefined): {
    address: string;
    zipcode: string;
    city: string;
} {
    const full = (raw ?? '').trim();
    if (!full) return { address: '', zipcode: '', city: '' };
    const match = full.match(/^(.*?)[,\s]+(\d{5})\s+(.+)$/);
    if (!match) return { address: full, zipcode: '', city: '' };
    return { address: match[1].trim().replace(/,\s*$/, ''), zipcode: match[2], city: match[3].trim() };
}
